import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, adminApi, getToken, setToken, clearToken } from "../lib/api";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [authed, setAuthed] = useState(null); // null=checking, true, false

  const verify = useCallback(async () => {
    if (!getToken()) { setAuthed(false); return; }
    try {
      await adminApi.get("/admin/verify");
      setAuthed(true);
    } catch {
      clearToken();
      setAuthed(false);
    }
  }, []);

  useEffect(() => { verify(); }, [verify]);

  const login = async (password) => {
    const { data } = await api.post("/admin/login", { password });
    setToken(data.token);
    setAuthed(true);
  };

  const logout = () => { clearToken(); setAuthed(false); };

  return (
    <AdminAuthContext.Provider value={{ authed, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
